import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "../../API/axios";
import { toast } from "react-hot-toast";
import CommentReply from "./CommentReply";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { post } from "../../config/imagesLink";
import LikesDetails from "./LikesDetails";
import { useTranslation } from "react-i18next";
import ModalForGuest from "../ModalForGuest";

const {
  like,
  celebrate,
  support,
  love,
  insightful,
  funny,
  likegif,
  commentLike,
} = post;

const CommentReplyActionSingle = ({
  item,
  AllPostList,
  postList,
  setSinglePostCommentList ,
  singlepostCommentList,
  emojiList,
  postId,
  setPostList,
  restrictedViewerToken,
  commentId,
  updateReplyCommentLike,
}) => {
  console.log("reply===>", commentId);
  const sessionId = localStorage.getItem("sessionId");
    const guestModeData = localStorage.getItem("guestMode");

  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  const [isHoveredRelike, setIsHoveredRelike] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const language = localStorage.getItem("Lang");

  const list = {
    visible: {
      opacity: 1,
    },
    hidden: {
      opacity: 0,
    },
  };

  //************************like Post start  ************************//
  const [selectedImg, setSelectedImage] = useState("");
  const [isLiking, setIsLiking] = useState(false);
  const [isLiked, setIsLiked] = useState(!!item?.isLiked);
  const [likedType, setLikedType] = useState(item?.likedType ?? null);
  const [localLikeCount, setLocalLikeCount] = useState(item?.likeCount ?? 0);

  React.useEffect(() => {
    setIsLiked(!!item?.isLiked);
    setLikedType(item?.likedType ?? null);
    setLocalLikeCount(item?.likeCount ?? 0);
  }, [item?.isLiked, item?.likedType]);


  const LikePost = async (liketype, imageName) => {
    if (isLiking) return;

    const wasLiked = Boolean(isLiked || item?.isLiked);
    const prevLikedType = changeLikedType || likedType || item?.likedType || null;

    setIsLiked(true);
    setLikedType(liketype);
    setChangeLikedType(liketype);
    setLocalLikeCount((count) => (wasLiked ? count : (count || 0) + 1));
    if (typeof updateReplyCommentLike === "function") {
      updateReplyCommentLike(postId, commentId, item.pstCmntRplyId, "like", liketype);
    }

    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      pstCmntRplyId: item.pstCmntRplyId,
      likeType: liketype,
            langKey: language === "en" ? "" : language,

    };
    setIsLiking(true);
    setTimeout(async () => {
      try {
        await axios
          .post(`PostAction/LikeCommentReply`, responseData)
          .then((res) => {
            // console.log(res);
            // toast.success(res.data.message);
            setToastMessage(res.data.message);
            setShowToast(true);
            // AllPostList();
            setSelectedImage(imageName);
            setIsHovered(false);
            setIsLiking(false);
            setIsLiked(true);
            setLikedType(liketype);
            setChangeLikedType(liketype);

          });
      } catch (e) {
        setIsLiking(false);
        setIsLiked(wasLiked);
        setLikedType(wasLiked ? prevLikedType : null);
        setChangeLikedType(wasLiked ? prevLikedType : null);
        setLocalLikeCount((count) => (wasLiked ? count : Math.max((count || 0) - 1, 0)));
        if (typeof updateReplyCommentLike === "function") {
          if (wasLiked) {
            updateReplyCommentLike(postId, commentId, item.pstCmntRplyId, "change", prevLikedType);
          } else {
            updateReplyCommentLike(postId, commentId, item.pstCmntRplyId, "unlike", null);
          }
        }
        if (e.response && e.response.status === 404) {
          setWarningToastMessage(e.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(e.response.data.message);
          setShowErrorToast(true);
        }
      }
    }, 1000);
  };

  
  const unLikePost = async () => {
    if (isLiking) return;

    const prevLiked = Boolean(isLiked || item?.isLiked);
    const prevLikedType = changeLikedType || likedType || item?.likedType || null;

    setIsLiked(false);
    setLikedType(null);
    setChangeLikedType(null);
    setLocalLikeCount((count) => Math.max((count || 0) - 1, 0));
    if (typeof updateReplyCommentLike === "function") {
      updateReplyCommentLike(postId, commentId, item.pstCmntRplyId, "unlike", null);
    }

    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: item.pstCmntRplyId,
            langKey: language === "en" ? "" : language,

    };
    setIsLiking(true);
    setTimeout(async () => {
      try {
        const res = await axios.post(
          `PostAction/UnlikeCommentReply`,
          responseData
        );
        // .then((res) => {
        // console.log(res);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        // AllPostList();
        setIsHovered(false);
        setIsLiking(false);
        setIsLiked(false);
        setLikedType(null);
        setChangeLikedType(null);

      //   const postDetailsResponse = await axios.get(
      //     `/Posts/GetPostInfo?DeviceType=Web&PostId=${postId}&RestrictedViewerToken=${restrictedViewerToken}`
      //   );
      //   console.log("postDetailsResponse", postDetailsResponse);
      //   const updatedPost = postDetailsResponse.data.responseData;
      //   console.log("updatedPost", updatedPost);

      //   // setPostList(updatedPost);
      //      setPostList((prev) =>
      //   prev.map((p) =>
      //     p.postInfo.postId === updatedPost.postInfo.postId
      //       ? updatedPost
      //       : p
      //   )
      // );
        // });
      } catch (e) {
        setIsLiking(false);
        setIsLiked(prevLiked);
        setLikedType(prevLikedType);
        setChangeLikedType(prevLikedType);
        setLocalLikeCount((count) => (prevLiked ? (count || 0) + 1 : count));
        if (typeof updateReplyCommentLike === "function" && prevLiked) {
          updateReplyCommentLike(postId, commentId, item.pstCmntRplyId, "like", prevLikedType);
        }
        if (e.response && e.response.status === 404) {
          setWarningToastMessage(e.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(e.response.data.message);
          setShowErrorToast(true);
        }
      }
    }, 1000);
  };

  //************************like Post End  ************************//

  const [showCommentsReply, setShowCommentsReply] = useState(false);
  const [changeLikedType, setChangeLikedType] = useState(null);
  const toggleReplyComment = () => {
    setShowCommentsReply(!showCommentsReply);
  };
  const customCount = item.likeCount + 1;

  const getLikeCount = () => {
    return localLikeCount;
  };

  const currentLikedType = changeLikedType ?? (isLiked ? likedType : null);

  const [showCommentReplyLikeModal, setShowCommentReplyLikeModal] =
    useState(false);
  const [postCommentReplyId, setPostCommentsReplyId] = useState(false);
  const [commentsReplyLikedType, setCommentsReplyLikedType] = useState(false);

  const handleShowCommentReplyLike = (item) => {
    console.log("comment rply id", item.pstCmntRplyId);
    setPostCommentsReplyId(item.pstCmntRplyId);
    setCommentsReplyLikedType(item.likedType);
    setShowCommentReplyLikeModal(true);
  };
  const handleCommentReplyLikeCloseModal = () => {
    setShowCommentReplyLikeModal(false);
  };

  const ReLikePost = async (liketype, imageName) => {
    if (isLiking) return;

    const currentType = changeLikedType || likedType || item?.likedType;
    if (Number(currentType) === Number(liketype)) {
      setIsHoveredRelike(false);
      return;
    }

    const wasLiked = Boolean(isLiked || item?.isLiked);
    if (!wasLiked) {
      setIsHoveredRelike(false);
      return LikePost(liketype, imageName);
    }

    const prevType = currentType;
    setChangeLikedType(liketype);
    setLikedType(liketype);
    setIsLiked(true);
    if (typeof updateReplyCommentLike === "function") {
      updateReplyCommentLike(postId, commentId, item.pstCmntRplyId, "change", liketype);
    }

    try {
      const responseData = {
        deviceType: "Web",
        sessionId: sessionId,
        pstCmntRplyId: item.pstCmntRplyId,
        likeType: liketype,
              langKey: language === "en" ? "" : language,

      };
      // console.log(responseData);
      setIsLiking(true);
      setLikedType(liketype);

      const res = await axios.post("/PostAction/ChangeCommentReplyLikeType", responseData);

      console.log("likedTyphgjhhje", res, item.likedType);
      // toast.success('gdhghdg', res.data.message);
      setToastMessage(res.data.message);
      setShowToast(true);
      // AllPostList();
      setSelectedImage(imageName);
      setIsHoveredRelike(false);
      setIsLiking(false);
      setIsLiked(true);
      setLikedType(liketype);
      setChangeLikedType(liketype);


      // Fetch the full post details using the post ID
      // const postDetailsResponse = await axios.get(`/Posts/GetPostInfo?DeviceType=Web&PostId=${postId}`);
      // const updatedPost = postDetailsResponse.data.responseData;
      // console.log('updatedPost', updatedPost);

      // // Update the existing post in the list
      // setPostList((prev) =>
      //   prev.map((post) =>
      //     post.postId === updatedPost.postId ? updatedPost : post
      //   )
      // );
    } catch (e) {
      setIsLiking(false);
      setLikedType(prevType);
      setChangeLikedType(prevType);
      if (typeof updateReplyCommentLike === "function") {
        updateReplyCommentLike(postId, commentId, item.pstCmntRplyId, "change", prevType);
      }
      console.log(e);
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const [followModal, setFollowModal] = useState(false);
      const closeModalData = () => {
        setFollowModal(false);
      };
  return (
    <>
    {guestModeData === "true" ? (
      <div className="commentAction ms-3">
        <span className="CommentlikeActions d-flex align-items-center">
          {isLiked === true ? (
            <div
              className="like-container pointer d-flex align-items-center me-2"
            
              onClick={() => {
                              setFollowModal(true);
                            }}
              whileHover={{ scale: 1.3 }}
              onMouseEnter={() => setIsHoveredRelike(true)}
              onMouseLeave={() => setIsHoveredRelike(false)}
            >
              {currentLikedType === 1 ? (
                <>
                  <img src={post.LikeGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">{t("Newsfeed.Like")}</p>
                </>
              ) : currentLikedType === 2 ? (
                <>
                  <img src={post.LoveGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">{t("Newsfeed.Love")}</p>
                </>
              ) : currentLikedType === 3 ? (
                <>
                  <img
                    src={post.LaughingGif}
                    width={15}
                    className="likepadding"
                  />
                  <p className="f-12 ms-1">{t("Newsfeed.Laugh")}</p>
                </>
              ) : currentLikedType === 4 ? (
                <>
                  <img src={post.WowGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">{t("Newsfeed.Wow")}</p>
                </>
              ) : currentLikedType === 5 ? (
                <>
                  <img src={post.AngryGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">{t("Newsfeed.Angry")}</p>
                </>
              ) : (
                <>
                  <img src={post.LikeGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">{t("Newsfeed.Like")}</p>
                </>
              )}
            </div>
          ) : (
            <motion.span
              className="f-12 me-2 pointer"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
               onClick={() => {
                              setFollowModal(true);
                            }}
            >
              {t("Newsfeed.Like")}
            </motion.span>
          )}
          {getLikeCount() > 0 ? (
            <span
              className={`commentLike me-2 ${!isLiked ? "like-details" : ""}`}
              onClick={() => handleShowCommentReplyLike(item)}
            >
              {getLikeCount()}
            </span>
          ) : null}

          {isHovered && (
            <motion.div
              className="reactionsHolder"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              variants={list}
              animate={isHovered ? "visible" : "hidden"}
            >
              {emojiList.map((item) => {
                return (
                  <div className="emoji-container" key={item.value}>
                    <motion.img
                      whileHover={{ scale: 1.5 }}
                      src={item.url}
                      alt=""
                      onClick={() => {
                        setFollowModal(true);
                      }}
                    />
                    <span className="emoji-name">{item.name}</span>
                  </div>
                );
              })}
            </motion.div>
          )}
          {isHoveredRelike && (
            <motion.div
              className="reactionsHolder"
              onMouseEnter={() => setIsHoveredRelike(true)}
              onMouseLeave={() => setIsHoveredRelike(false)}
              variants={list}
            >
              {emojiList?.map((item) => {
                return (
                  <div className="emoji-container" key={item.value}>
                    <motion.img
                      whileHover={{ scale: 1.5 }}
                      src={item.url}
                      alt=""
                      onClick={() => {
                        setFollowModal(true);
                      }}
                    />
                    <span className="emoji-name">{item.name}</span>
                  </div>
                );
              })}
            </motion.div>
          )}
        </span>
      </div>
      ) : (
      <div className="commentAction ms-3">
          <span className="CommentlikeActions d-flex align-items-center">
            {isLiked === true ? (
              <div
                className="like-container pointer d-flex align-items-center me-2"
                onClick={() => unLikePost()}
                whileHover={{ scale: 1.3 }}
                onMouseEnter={() => setIsHoveredRelike(true)}
                onMouseLeave={() => setIsHoveredRelike(false)}
              >
                {currentLikedType === 1 ? (
                  <>
                    <img src={post.LikeGif} width={15} className="likepadding" />
                    <p className="f-12 ms-1">{t("Newsfeed.Like")}</p>
                  </>
                ) : currentLikedType === 2 ? (
                  <>
                    <img src={post.LoveGif} width={15} className="likepadding" />
                    <p className="f-12 ms-1">{t("Newsfeed.Love")}</p>
                  </>
                ) : currentLikedType === 3 ? (
                  <>
                    <img
                      src={post.LaughingGif}
                      width={15}
                      className="likepadding"
                    />
                    <p className="f-12 ms-1">{t("Newsfeed.Laugh")}</p>
                  </>
                ) : currentLikedType === 4 ? (
                  <>
                    <img src={post.WowGif} width={15} className="likepadding" />
                    <p className="f-12 ms-1">{t("Newsfeed.Wow")}</p>
                  </>
                ) : currentLikedType === 5 ? (
                  <>
                    <img src={post.AngryGif} width={15} className="likepadding" />
                    <p className="f-12 ms-1">{t("Newsfeed.Angry")}</p>
                  </>
                ) : (
                  <>
                    <img src={post.LikeGif} width={15} className="likepadding" />
                    <p className="f-12 ms-1">{t("Newsfeed.Like")}</p>
                  </>
                )}
              </div>
            ) : (
              <motion.span
                className="f-12 me-2 pointer"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={() => {
                  LikePost(1, like);
                }}
              >
                {t("Newsfeed.Like")}
              </motion.span>
            )}
            {getLikeCount() > 0 ? (
              <span
                className={`commentLike me-2 ${!isLiked ? "like-details" : ""}`}
                onClick={() => handleShowCommentReplyLike(item)}
              >
                {getLikeCount()}
              </span>
            ) : null}

            {isHovered && (
              <motion.div
                className="reactionsHolder"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                variants={list}
                animate={isHovered ? "visible" : "hidden"}
              >
                {emojiList.map((item) => {
                  return (
                    <div className="emoji-container" key={item.value}>
                      <motion.img
                        whileHover={{ scale: 1.5 }}
                        src={item.url}
                        alt=""
                        onClick={() => {
                          LikePost(item.value, item.name);
                        }}
                      />
                      <span className="emoji-name">{item.name}</span>
                    </div>
                  );
                })}
              </motion.div>
            )}
            {isHoveredRelike && (
              <motion.div
                className="reactionsHolder"
                onMouseEnter={() => setIsHoveredRelike(true)}
                onMouseLeave={() => setIsHoveredRelike(false)}
                variants={list}
              >
                {emojiList?.map((item) => {
                  return (
                    <div className="emoji-container" key={item.value}>
                      <motion.img
                        whileHover={{ scale: 1.5 }}
                        src={item.url}
                        alt=""
                        onClick={() => {
                          ReLikePost(item.value, item.name);
                        }}
                      />
                      <span className="emoji-name">{item.name}</span>
                    </div>
                  );
                })}
              </motion.div>
            )}
          </span>
        </div> 
      )}


      {followModal && <ModalForGuest closeModalData={closeModalData} />}

      {showCommentsReply && (
        <CommentReply
          item={item}
          AllPostList={AllPostList}
          setPostList={setPostList}
          postId={postId}
          commentId={item.pstCmntId}
          toggleReplyComment={toggleReplyComment}
        />
      )}

      <LikesDetails
        showCommentReplyLikeModal={showCommentReplyLikeModal}
        handleCommentReplyLikeCloseModal={handleCommentReplyLikeCloseModal}
        commentsReplyLikedType={commentsReplyLikedType}
        postCommentReplyId={postCommentReplyId}
      />

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default CommentReplyActionSingle;
